<template>
  <div class="banner_wrap">
    <div class="banner_container">
      <div class="banner_left"></div>
      <div class="banner_swipe">
        <swiper class="banner_swiper" :options="swiperOption">

          <swiper-slide class="banner_slide" v-for="banner in bannerList" :key="`banner${banner.b_idx}`"
                        :style="`background-image:url(${returnImage(banner)}`"
          >
            <div class="banner_slide_back" @click="openUrl(banner.b_url)"></div>
          </swiper-slide>

          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="banner_right"></div>
    </div>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";

export default {
  name: "BannerComponent",
  mixins: [imageOption],
  components: {
    Swiper,
    SwiperSlide
  },
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      bannerList: [],
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
    this.getBanner();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    getBanner() {
      let params = {ip: 0};
      try {
        this.$api.$banner.getBanner(params).then(res => res.Data.Result).then(res => {
          if (res.Info.type == 1) {
            this.bannerList = res.List
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    returnImage(banner) {
      return `${banner.MobileFiles[0].org_url}?${this.setImageOptions(710, 566, 'jpg')}`;
    },
    openUrl(url) {
      if (!util.isEmpty(url)) {
        if (url.includes('https://') || url.includes('http://')) {
          window.open(url, '_blank')
        }else{
          window.open(`http://${url}`, '_blank')
        }
      }
    }
  },
  watch: {},
}
</script>

<style scoped>
.banner_slide_back{
  width: 100%;
  height: 100%;
}
</style>